const asUrlPrefix = '_as_prefix';

/**
 * Creates an URL object, it will automaticly prefix the url with a protocol/domain if the url doesn't start with a protocol. (otherwise it's not possible to make the URL object)
 * @param url
 */
export function createUrlObject(url: string) {
	// The URL class requires a protocol
	const protocolRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
	if (!protocolRegex.test(url)) {
		const urlObj = new URL(url, 'http://myapi.com');
		urlObj[asUrlPrefix] = true;
		return urlObj;
	} else {
		return new URL(url);
	}
}

/**
 * Get's the real url (if the 'createUrlObject' method was used it will strip the prefix  from the url)
 * @param url
 */
export function getUrlObjectHref(url: URL) {
	if (url.href.startsWith('http://myapi.com')) {
		if (url[asUrlPrefix] === false) {
			console.warn(`url ${url.href} starts with myapi but does not contain our prefix.`); // NOSONAR - warn the developer
		}
		return url.href.replace(/^http:\/\/myapi.com/, '');
	} else {
		return url.href;
	}
}
